'use client';

import React from 'react';
import FadeInDiv from '../ui-elements/fadeIn/FadeInDiv.component';

interface ComponentWrapperProps {
  children: React.ReactNode;
  backgroundImage?: string;
}

const ComponentWrapper: React.FC<ComponentWrapperProps> = ({ children, backgroundImage }) => {
  return (
    <div className="py-20 px-10 lg:py-32 lg:mt-0 relative">
      {backgroundImage && (
        <div
          className="absolute inset-0 w-full h-full z-0"
          style={{
            backgroundImage: `url('${backgroundImage}')`,
            backgroundAttachment: 'fixed',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        />
      )}
      <div className="relative z-10">
        <FadeInDiv>
          <div>
            <div className="margin-auto block">{children}</div>
          </div>
        </FadeInDiv>
      </div>
    </div>
  );
};

export default ComponentWrapper;
